import { Button, CircularProgress, Grid } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { ErrorModal } from "../../../../../components/modals/error-modal";
import MesfModal from "../../../../../components/modals/modal.mesf";
import {
	EmailAddressFormValues,
	INITIAL_VALUES,
} from "../../../emailTopics/models/EmailAddress";
import {
	setEmailAddressTopics,
	upsertEmailAddress,
} from "../../../emailTopics/repositories/EmailTopicsRepository";
import { useEmailAddressesContext } from "../../context/EmailAddressesContext";
import { EmailAddressFormFields } from "./EmailAddressFormFields";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
};

export const CreateEmailAddress = ({ show, onHide }: Props) => {
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [error, setError] = useState("");
	const {
		state: { topics },
	} = useEmailAddressesContext();

	const { control, handleSubmit, reset } = useForm<EmailAddressFormValues>({
		defaultValues: INITIAL_VALUES,
	});

	// The address has to exist before its topics can be assigned, so the id returned by the upsert
	// feeds the second call.
	const onSubmit: SubmitHandler<EmailAddressFormValues> = async (data) => {
		setIsSubmitLoading(true);
		try {
			const emailAddressId = await upsertEmailAddress({
				EmailAddressId: null,
				Address: data.Address,
			});

			if (emailAddressId) {
				await setEmailAddressTopics({
					EmailAddressId: emailAddressId,
					TopicIdsTO: data.TopicIdsTO,
					TopicIdsCC: data.TopicIdsCC,
					TopicIdsBCC: data.TopicIdsBCC,
					IncludeSystem: false,
				});
			}

			onHide(true);
		} catch (e: any) {
			setError(e?.message || "Error saving email address");
		} finally {
			setIsSubmitLoading(false);
		}
	};

	useEffect(() => {
		if (show) reset(INITIAL_VALUES);
	}, [show]);

	return (
		<>
			<ErrorModal error={error} onHide={() => setError("")} />
			<MesfModal
				title="NEW EMAIL ADDRESS"
				open={show}
				handleClose={() => onHide(false)}
				id="create-email-address-modal"
				maxWidth="md"
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<MesfModal.Content style={{ padding: "15px 30px 0" }}>
						<EmailAddressFormFields control={control} topics={topics} />
					</MesfModal.Content>
					<MesfModal.Actions>
						<Grid
							container
							spacing={2}
							justifyContent="flex-end"
							style={{ padding: "1rem" }}
						>
							<Grid item md={3} xs={12}>
								<Button
									fullWidth
									variant="contained"
									onClick={() => onHide(false)}
									disabled={isSubmitLoading}
								>
									CANCEL
								</Button>
							</Grid>
							<Grid item md={3} xs={12}>
								<Button
									fullWidth
									type="submit"
									variant="contained"
									color="primary"
									disabled={isSubmitLoading}
								>
									{isSubmitLoading ? <CircularProgress size={24} /> : "CREATE"}
								</Button>
							</Grid>
						</Grid>
					</MesfModal.Actions>
				</form>
			</MesfModal>
		</>
	);
};
